import React from 'react'
import { useTheme } from '@material-ui/core/styles'

type TemplateToolbarButtonProps = {
  onClick: () => void
  title: string
}

const TemplateToolbarButton = ({ onClick, title }: TemplateToolbarButtonProps): JSX.Element => {
  const theme = useTheme()

  const styles: React.CSSProperties = {
    color: theme.palette.primary.main,
    fontFamily: theme.typography?.fontFamily as string,
    fontSize: '0.85rem',
    padding: '2px 8px',
    height: 28,
    lineHeight: '24px',
    display: 'inline-flex',
    alignItems: 'center',
    cursor: 'pointer',
    borderRadius: 4
  }

  return (
    <div
      className="rdw-option-wrapper rte-template-button"
      onClick={onClick}
      title={title}
      style={styles}
    >
      {title}
    </div>
  )
}

export default TemplateToolbarButton


